import React, { Component } from 'react';

class Statements extends Component {
  constructor() {
    super();
    this.state = {};
  }
  render() {
    return (
        <div className="container">
          <h1>Statements Page</h1>
        </div>
    );
  }
}
export default Statements;
